module.exports = __webpack_public_path__ + "f669ccdff9307bfe56829cccc87bdd37.pdf";